import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import assets from "../assets/imgs";
import DOMPurify from "dompurify";
import CalendarPopup from "./CalendarPopup";
import config from "../config/config";
import {useUser} from "../context/UserContext";
import Buttons from "./Buttons";
import MonthlyReportWriteBox from './MonthlyReportWriteBox';

const API_URL = config.API_URL;

function BoardWriteBox({boardTypeId, boardTypeName, boardCategoryList, onClose, boardId, edit }){
  const {account, authority} = useUser();
  
  //boardCategoryList는 네트워킹에서만 쓰는 소분류임
  // const [htmlValue, setHtmlValue] = useState('');
  // const [selectedCategory, setSelectedCategory] = useState(null);
  const [boardContents, setBoardContents] = useState([]);
  const [editing, setEditing] = useState(edit);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(null);
  const [checkMonthlyReport, setCheckMonthlyReport] = useState(false);
  const [monthlyReportOrNot, setMonthlyReportOrNot] = useState(false);
  const [monthModalOpen, setMonthModalOpen] = useState(false);

  const planPage = (boardTypeId === "Plan");
  const now = new Date();
  const kstNow = new Date(now.getTime() + (9 * 60 * 60 * 1000)); // UTC+9 적용
  const today = kstNow.toISOString().split("T")[0];
  
  const popupAnchorRef = useRef(null);
  
  const handleDatePickerOpen = (key, event) => {
    event.stopPropagation();
    popupAnchorRef.current = event.target; // 클릭된 DOM 저장
    setIsDatePickerOpen(key);
  };
  // const [formData, setFormData] = useState({}); // 변경시 입력 및 저장시 이용 데이터

  // console.log('onclose state', onClose);

  const handleUpdate = async ()=>{
    console.log('update 요청');
    await uploadBoard();
    // onClose();
  }
  // const handleCategory = (key) => {
  //   setSelectedCategory(key);
  // };
  const handleChange = (field, value) =>{
    setBoardContents((prev) => {
      let newContents = { ...prev, [field]: value };
  
      if (field === "start_date" && newContents.end_date && new Date(value) > new Date(newContents.end_date)) {
        alert("시작 날짜가 종료 날짜 보다 느립니다.");
        return prev; // 상태를 그대로 유지
      }
  
      if (field === "end_date" && newContents.start_date && new Date(value) < new Date(newContents.start_date)) {
        alert("종료 날짜가 시작 날짜 보다 빠릅니다.");
        return prev; // 상태를 그대로 유지
      }
  
      return newContents;
    });
    // setBoardContents((prev) => ({
    //   ...prev,
    //   [field]: value,
    // }));
  }

  const handleEdit = async () =>{
    if(editing){
      const confirmEndEdit = window.confirm('저장되지 않은 수정사항은 반영되지 않습니다. 수정을 중지하시겠습니까?');
      if(!confirmEndEdit){
        return null;
      }else{
        await fetchData();
        setEditing(false);
      }
    }else{
      setEditing(true);
    }
  }
  const handleDelete = async ()=>{
    if(!boardId){
      alert('잘못된 접근입니다.');
      return;
    }
    try{
      const response = await fetch(`${API_URL}/api/board/delete${boardTypeId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({_id: boardId}),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.result) {
        alert(`${boardTypeName} 글이 성공적으로 제거되었습니다.`);
        onClose(true);

      } else {
        // console.log(`${result.message}`);
        alert(`삭제에 실패하였습니다. ${result.message}`);
      }

    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    }
  }

  // const handleOverlayClick = (e)=>{
  //   if(e.target === e.currentTarget){
  //     onClose();
  //   }
  // }
  // ESC 키로 모달 닫기
  // useEffect(() => {
  //   console.log("isDatePickerOpen 상태 변경됨:", isDatePickerOpen);
  // }, [isDatePickerOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const uploadBoard = async () =>{
    try {
      if (!boardContents.title 
        || !boardContents.contents 
        || (boardTypeId === 'Network' && !boardContents.category)
        || (boardTypeId === "Plan" && (!boardContents.start_date || !boardContents.end_date))
      ) {
        alert("모든 필수 항목을 입력하세요.");
        return;
      }
      // for (const field of newDataTitles) {
      //   if (field.req) {
      //     const value = formData[field.key];
      //     if (value === "" || value === undefined || value === null) {
      //       alert(`${field.label}이(가) 없습니다.`);
      //       return; // 저장 중단
      //     }
      //   }
      // }

      // const {file_data, ...jsonData} = formData;
      // const formDataToSend = new FormData();
      // formDataToSend.append("file_data", file_data);
      // formDataToSend.append("json", JSON.stringify(jsonData));
      let jsonBody 
      if(boardId){
        jsonBody = JSON.stringify({...boardContents, _id : boardId});
      }else{
        jsonBody = JSON.stringify(boardContents);
      }

      const response = await fetch(`${API_URL}/api/board/put${boardTypeId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: jsonBody,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.result) {
        alert(`${boardTypeName} 글이 성공적으로 저장되었습니다.`);
        onClose(true);
      } else {
        console.log(`${result.message}`);
        alert(`저장에 실패하였습니다.`);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    }
  }

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/getBoardDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          _id : boardId,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          title : row.title || '-',
          contents : row.contents || '-',
          category : row.category || '-',
          name: row.name || "-", 
          start_date : row.start_date ? row.start_date.split("T")[0] : "-",
          end_date : row.end_date ? row.end_date.split("T")[0] : "-",
          date: row.up_date ? row.up_date.split("T")[0] : "-", // 날짜만 추출,
          account: row.account || "-",
        }));
        setMonthlyReportOrNot(result.value[0].monthly_report === 1);
        setBoardContents(formattedData[0] || {});
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } 
  };
  useEffect(() =>  {
    if(boardId && !editing){
      fetchData();
    }
  }, [boardId]);

  useEffect(() => {
    // setHtmlValue('');
    setBoardContents([]);
    // setEditing(false);
    setMonthModalOpen(false);
  }, [onClose]);

  const handleMonthlyReportOpen = () => {
    if(authority <= 2){
      alert('권한이 부족합니다.');
    }else{
      setMonthModalOpen(true);
    }
  }

  const handleMonthlyReportClose = () =>{
    setMonthModalOpen(false);
  }

  const quillModules ={
    toolbar: [
      [{ font: [] }], // 글꼴 선택
      [{ size: [] }], // 글자 크기
      [{ color: [] }, { background: [] }], // 글자색 및 배경색
      ["bold", "italic", "underline", "strike"], // 굵기, 기울기, 밑줄, 취소선
      [{ script: "sub" }, { script: "super" }], // 위첨자, 아래첨자
      [{ list: "ordered" }, { list: "bullet" }], // 순서 있는 목록, 순서 없는 목록
      [{ indent: "-1" }, { indent: "+1" }], // 들여쓰기 감소, 증가
      [{ align: [] }], // 정렬
      ["link", "image"], // 링크, 이미지 업로드
      ["blockquote", "code-block"], // 인용구, 코드 블록
      [{ direction: "rtl" }], // 오른쪽에서 왼쪽 정렬
      ["clean"], // 포맷 초기화
    ],
  }
  // console.log('boardaccount:', boardContents.account);
  // console.log('user', account, authority);

  console.log('editing is ', editing, 'server test', monthlyReportOrNot);

  return (
    <div style={styles.overlay}>
      <div style={{...styles.modal,
        ...(planPage ? {width : "50%"} : {})
      }}>
        <div style={styles.header}>
          <h3 className='font-s-head4-semibold'>{editing ? `${boardTypeName} 작성` : `${boardTypeName}`}</h3>
          <div style={styles.topRightHeader}>
            {((authority >= 5 ||( boardContents.account == account)) && boardId) &&
              <>
                <div onClick={handleDelete} style={topRightHeaderIcon}>
                  <assets.icons.bin />
                </div>
                <div onClick={() =>{
                  handleEdit();
                  // if(editing){
                  //   return;
                  // }else{
                  //   handleEdit();
                  // }
                }} style={topRightHeaderIcon}>
                  <assets.icons.edit style={{color: "black"
                    // editing ? "#A3A3AB" : "black"
                    }}/>
                </div>
              </>
            }
            <div style={styles.xBox} onClick={() => onClose(false)}>
              <assets.icons.icon_x/>
            </div>
          </div>
        </div>
        <div style={styles.body}>
          {/* 타이틀 입력 */}
          <div style={styles.setSection}>
            <h3 className='font-body4-semibold'>{planPage ? "일정 제목" : "글제목"}</h3>
            {editing ? (
              <input
                type="text"
                style={styles.textInput}
                value={boardContents.title || ""}
                onChange={(e) => handleChange("title", e.target.value)}
              />
            ): (
              <p className='font-body3-semibold' style={styles.textInput}>{boardContents.title}</p>
            )}            
          </div>

          {/* 다른 부분 입력부 */}
          {planPage ? (
            <>
              <div style={styles.setSection}>
                <h3 className='font-body4-semibold'>일정</h3>
                <div style={{display: "flex", gap: "12px", justifyContent: "space-between",}}>
                  <div style={{...styles.dateInput, cursor: editing ? "pointer" : "default"}} 
                    onClick={(e) => {
                      if (!editing) return; // editing이 false면 클릭 이벤트 무시
                      handleDatePickerOpen('start_date', e);
                      // e.stopPropagation();
                      // setIsDatePickerOpen("start_date");
                    }}>
                    <img src={assets.icons.calendar} style={styles.calendarIcon}/>
                    <p>{(!boardContents.start_date || boardContents.start_date === "-") ?
                     (editing ? "시작 일정을 선택해주세요" : "-") : boardContents.start_date}</p>
                     {isDatePickerOpen === "start_date" && (
                        <CalendarPopup
                          selectedDate={boardContents.start_date}
                          onSelect={(date) => handleChange("start_date", date)}
                          onClose={() => setIsDatePickerOpen(null)}
                          anchorRef={popupAnchorRef}
                        />
                      )}
                  </div>
                  
                  <div style={{...styles.dateInput, cursor: editing ? "pointer" : "default"}} onClick={(e) => {
                      if (!editing) return; // editing이 false면 클릭 이벤트 무시
                      handleDatePickerOpen('end_date', e);

                      // e.stopPropagation();
                      // setIsDatePickerOpen("end_date");
                    }}>
                    <img src={assets.icons.calendar} style={styles.calendarIcon}/>
                    <p>{(!boardContents.end_date || boardContents.end_date === "-") ?
                     (editing ? "종료 일정을 선택해주세요" : "-") : boardContents.end_date}</p>
                     {isDatePickerOpen === "end_date" && (
                        <CalendarPopup
                          selectedDate={boardContents.end_date}
                          onSelect={(date) => handleChange("end_date", date)}
                          onClose={() => setIsDatePickerOpen(null)}
                          anchorRef={popupAnchorRef}
                        />
                      )}
                  </div>
                  
                </div>
              </div>
              {/* <div style={{...styles.setSection, flex:1}}>
                <h3 className='font-body4-semibold'>내용</h3>
                {editing ? (
                  <textarea
                    type="text"
                    style={{...styles.textInput, flex: 1, resize: "none", overflowY: "auto", wordBreak: "break-word", whiteSpace:"pre-wrap"}}
                    value={boardContents.contents || ""}
                    onChange={(e) => handleChange("contents", e.target.value)}
                  />
                ): (
                  <p className='font-body3-semibold' style={{...styles.textInput, flex: 1, alignItems: "flex-start", padding: "12px"}}>{boardContents.contents}</p>
                )}            
              </div> */}
            </>
          ):(
            <>
              <div style={styles.setSection}>
                <h3 className='font-body4-semibold'>게시판</h3>
                <p className='font-body3-semibold' style={styles.textInput}>{boardTypeName}</p>
              </div>
              {boardCategoryList && (
                <div style={styles.setSection}>
                  <h3 className='font-body4-semibold'>분류</h3>
                  {editing ? (
                    <select
                      value={boardContents.category || ""}
                      onChange={(e) => handleChange("category", e.target.value)}
                      style={styles.textInput}
                    >
                      <option value="" disabled>선택</option>
                      {boardCategoryList.map((option) => (
                        <option key={option.key} value={option.key}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    // <select value = {selectedCategory ?? ""} onChange={(e) => handleCategory(e.target.value)}>
                    //   <option value ="" disabled>선택</option>
                    //   {boardCategoryList.map((option) =>(
                    //     <option key= {option.key} value ={option.key}>
                    //       {option.label}
                    //     </option>
                    //   ))}
                    // </select>
                  ): (
                    <p className='font-body3-semibold' style={styles.textInput}>
                      {boardCategoryList.find(cat => cat.key === boardContents.category)?.label || "없음"}
                    </p>
                  )}
                </div>
              )}          
              {/* {editing ? (
                <ReactQuill
                  theme="snow"
                  value={boardContents.contents || ""}
                  onChange={(content) => handleChange("contents", content)}
                  style={styles.quillStyle}
                  modules={quillModules}
                />
                // <ReactQuill theme = "snow" value = {htmlValue} onChange={setHtmlValue} style={styles.quillStyle}/>
              ): (
                <div style={{...styles.setSection, flex:1}}>
                  <h3 className='font-body4-semibold'>글 내용</h3>
                  <div style={styles.quillOutputStyle} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(boardContents.contents) }}
                    className='ql-editor'></div>
                </div>
              )} */}
            </>
          )}
          {editing ? (
            <ReactQuill
              theme="snow"
              value={boardContents.contents || ""}
              onChange={(content) => handleChange("contents", content)}
              style={styles.quillStyle}
              modules={quillModules}
            />
            // <ReactQuill theme = "snow" value = {htmlValue} onChange={setHtmlValue} style={styles.quillStyle}/>
          ): (
            <div style={{...styles.setSection, flex:1}}>
              <h3 className='font-body4-semibold'>내용</h3>
              <div style={styles.quillOutputStyle} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(boardContents.contents) }}
                className='ql-editor'></div>
            </div>
          )}

          {/* 등록 버튼 */}
          {editing && (
            <div style={styles.btnLine}>
              {planPage ? (                
                <div style={styles.monthCheckBox} onClick={() => {setCheckMonthlyReport(!checkMonthlyReport);}}>
                  <input style ={{width: "20px", height: "20px", cursor:"pointer"}} type='checkbox' checked={checkMonthlyReport}/>
                  <p className='font-body2-semibold'>월간 활동 내역</p>
                </div>
              ):(
                <div></div>
              )}
              <div style={styles.btnUpload} onClick={handleUpdate} className='font-body2-semibold'> {planPage ? "일정 등록": "글올리기"}</div>
            </div>
          )}
          {(!editing && monthlyReportOrNot && boardId) && (
            (authority >= 5) ? (
              <Buttons.MainButton text={'제출 내역'} onRed={false} onClick={handleMonthlyReportOpen} />
            ):(
              <>
                <div></div>
                <Buttons.MainButton text={'제출 하기'} onRed={true} onClick={handleMonthlyReportOpen}/>
              </>
            )
          )}
        </div>
      </div>
      {monthModalOpen && (
        <MonthlyReportWriteBox onClose={handleMonthlyReportClose} boardId={boardId} title={boardContents.title} startDate={boardContents.start_date} endDate={boardContents.end_date}/>
      )}
    </div>
  );
}

const topRightHeaderIcon = {
  cursor:"pointer",
  width: "20px",
  height:"20px"
};

const styles ={
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "20px",
    width: "80%",
    height: "80%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  header:{
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--grayscale_20)",
    justifyContent: "space-between",
    padding: "14px 20px",
    borderTopRightRadius : "20px",
    borderTopLeftRadius : "20px"
  },
  topRightHeader: {
    display: "flex",
    gap: "40px",
    alignItems: "center",
  },
  xBox:{
    ...topRightHeaderIcon,
    display:"flex",
    alignItems:"center",
    justifyContent: "center",    
  }, 
  body:{
    display: "flex",
    flexDirection : "column",
    padding: "35px 35px 40px 35px",
    flex: 1,
    overflow: "auto"
  },
  setSection:{
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "20px",
  },
  textInput:{
    height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px" ,
    display: "flex", alignItems: "center", minHeight: "45px",
  },
  dateInput: {
    display:"flex", gap: "10px", height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px", 
    alignItems: "center", position:"relative", flex: 1
  },
  btnLine: {
    display: "flex",
    justifyContent: "space-between",
  },
  calendarIcon: {
    width:"20px",
    height: "20px"
  },
  quillStyle:{
    // borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    // padding: "12px",
    marginBottom: "80px",
    flex: 1
  },
  quillOutputStyle:{
    borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    padding: "12px",
    flex: 1
  },
  monthCheckBox:{
    display: "flex", gap: "6px", alignItems: "center", cursor: "pointer"
  },
  btnUpload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    backgroundColor : "var(--primary-crimson_40)",
    borderRadius: "8px",
    cursor: "pointer",
    height: "48px", width:"150px"
  }
}


export default BoardWriteBox;